import {useEffect, useState} from 'react';

import {fetchAllStorageImages} from '../firebaseTools';
import {getUniqueImagesFromLinks, mergeUniqueImageUrls} from '../tools';

const EMPTY_LINKS = [];

export const useStorageImages = (addError, enabled = false, links = EMPTY_LINKS) => {
	const [storageImages, setStorageImages] = useState([]);
	const [loadingImages, setLoadingImages] = useState(false);
	const linkImagesKey = getUniqueImagesFromLinks(links).join('\0');

	useEffect(() => {
		if (!enabled) {
			setStorageImages([]);
			setLoadingImages(false);
			return undefined;
		}

		let cancelled = false;
		const linkImages = getUniqueImagesFromLinks(links);
		(async () => {
			setLoadingImages(true);
			const fetchedImages = await fetchAllStorageImages(addError);
			const images = mergeUniqueImageUrls(fetchedImages, linkImages);
			if (!cancelled) {
				setStorageImages(images);
				setLoadingImages(false);
			}
		})();
		return () => {
			cancelled = true;
		};
	}, [addError, enabled, linkImagesKey]);

	return {storageImages, loadingImages};
};
